// TableEventAdmin.js
import React, { useEffect, useState } from 'react';
import { Table, Checkbox, Button, message } from 'antd';
import 'antd/dist/reset.css'; // หรือ 'antd/dist/antd.css' ขึ้นอยู่กับเวอร์ชันที่ใช้

import eventAdminService from '../services/event-admin.service';

const TableEventAdmin = ({ id }) => { // Destructure id จาก props
    const [data, setData] = useState([]);
    const [modifiedData, setModifiedData] = useState(new Map()); // สำหรับติดตามข้อมูลที่ถูกแก้ไข
    const [loading, setLoading] = useState(false); // สำหรับสถานะการโหลดเมื่อกด Save
    const [fetching, setFetching] = useState(false); // สำหรับสถานะการโหลดเมื่อดึงข้อมูลจาก API
    const [isSaveDisabled, setIsSaveDisabled] = useState(true); // สำหรับการตรวจสอบการปิดใช้งานปุ่ม Save

    // ฟังก์ชันสำหรับจัดการการเปลี่ยนแปลง Checkbox แถว
    const handleRowToggle = (record) => {
        const newData = data.map((item) => {
            if (item.key === record.key) {
                const newEnabled = !item.enabled;
                const updatedItem = {
                    ...item,
                    enabled: newEnabled,
                    // ถ้า enabled เป็น false ให้ reset ค่า EventAutoMessageUse, FullLoopUse, AutoDocUse เป็น false ด้วย
                    ...(newEnabled ? {} : {
                        EventAutoMessageUse: false,
                        FullLoopUse: false,
                        AutoDocUse: false,
                    })
                };

                // อัปเดต modifiedData
                setModifiedData(prev => {
                    const updatedMap = new Map(prev);
                    updatedMap.set(item.key, updatedItem);
                    return updatedMap;
                });

                return updatedItem;
            }
            return item;
        });
        setData(newData);
    };

    // ฟังก์ชันสำหรับจัดการการเปลี่ยนแปลง Checkbox ในเซลล์
    const handleCellToggle = (record, field) => {
        const newData = data.map((item) => {
            if (item.key === record.key) {
                const updatedItem = { ...item, [field]: !item[field] };

                // อัปเดต modifiedData
                setModifiedData(prev => {
                    const updatedMap = new Map(prev);
                    updatedMap.set(item.key, updatedItem);
                    return updatedMap;
                });

                return updatedItem;
            }
            return item;
        });
        setData(newData);
    };

    // ฟังก์ชันสำหรับจัดการการบันทึกข้อมูล
    const handleSave = async () => {
        if (modifiedData.size === 0) {
            message.info('ไม่มีข้อมูลที่ถูกแก้ไขเพื่อบันทึก');
            return;
        }

        console.log('Company ID:', id);

        setLoading(true);
        try {
            // สร้างอาเรย์ของออบเจ็กต์ที่ถูกแก้ไข
            const updatedDataArray = Array.from(modifiedData.values()).map(item => ({
                Id: Number(item.key), // ใช้ Id จาก key
                Status: item.enabled ? true : false,
                EventAutoMessageUse: item.EventAutoMessageUse,
                FullLoopUse: item.FullLoopUse,
                AutoDocUse: item.AutoDocUse,
                Name: item.Name,
                Description: item.Description,
            }));

            // สร้าง payload ที่ประกอบด้วย company_id และ data
            const payload = {
                company_id: parseInt(id),
                data: updatedDataArray,
            };

            console.log('Payload:', payload);

            // ส่ง Request ไปยัง Backend
            await eventAdminService.mappingCompany(payload);

            message.success('บันทึกข้อมูลสำเร็จ!');

            // รีเซ็ต modifiedData หลังจากบันทึกสำเร็จ
            setModifiedData(new Map());
        } catch (error) {
            console.error('Error saving data:', error);
            message.error(error.response?.data?.message || 'เกิดข้อผิดพลาดในการบันทึกข้อมูล');
        } finally {
            setLoading(false);
        }
    };

    // ฟังก์ชันสำหรับดึงข้อมูลจาก API
    const getdataAll = async () => {
        setFetching(true); // เริ่มต้นการโหลดข้อมูล
        try {
            const response = await eventAdminService.getallEvent({
                company_id: parseInt(id),
            });
            console.log('Response:', response);

            // สมมติว่า response.data.data เป็น array ของ event objects
            const items = response.data.data; // ปรับตามโครงสร้างจริง

            // แปลงข้อมูลให้อยู่ในรูปแบบที่ตารางต้องการ
            const formattedData = items.map(item => ({
                key: item.MasterMessageEventTemplateId,
                Name: item.Name, // Optional: หากต้องการแสดงในตาราง
                Description: item.Description, // Optional: หากต้องการแสดงในตาราง
                EventAutoMessageUse: item.EventAutoMessageUse || false,
                FullLoopUse: item.FullLoopUse || false,
                AutoDocUse: item.AutoDocUse || false,
                // ถ้า EventAutoMessageUse, FullLoopUse, หรือ AutoDocUse ตัวใดตัวหนึ่งเป็น true, ตั้งค่า enabled เป็น true
                enabled: item.EventAutoMessageUse || item.FullLoopUse || item.AutoDocUse,
            }));
            setData(formattedData);
        } catch (error) {
            console.error('Error fetching data:', error);
            message.error(error.response?.data?.message || 'เกิดข้อผิดพลาดในการดึงข้อมูล');
        } finally {
            setFetching(false); // สิ้นสุดการโหลดข้อมูล
        }
    };

    useEffect(() => {
        getdataAll();
    }, []);

    // เพิ่ม useEffect เพื่อตรวจสอบว่าปุ่ม Save ควรจะถูก disable หรือไม่
    useEffect(() => {
        if (modifiedData.size === 0) {
            setIsSaveDisabled(true);
            return;
        }
        const hasInvalidEntries = Array.from(modifiedData.values()).some(item => item.enabled && !item.EventAutoMessageUse && !item.FullLoopUse && !item.AutoDocUse);
        setIsSaveDisabled(hasInvalidEntries);
    }, [modifiedData]);

    // กำหนดคอลัมน์ของตาราง
    const columns = [
        {
            title: 'Status',
            dataIndex: 'action',
            key: 'action',
            render: (_, record) => (
                <Checkbox
                    checked={record.enabled}
                    onChange={() => handleRowToggle(record)}
                />
            ),
            width: 100,
            align: 'center',
        },
        {
            title: 'Name',
            dataIndex: 'Name',
            key: 'Name',
            align: 'center',
        },
        {
            title: 'Description',
            dataIndex: 'Description',
            key: 'Description',
            align: 'center',
        },
        {
            title: 'EventAutoMessageUse',
            dataIndex: 'EventAutoMessageUse',
            key: 'EventAutoMessageUse',
            render: (text, record) => (
                <Checkbox
                    checked={record.EventAutoMessageUse}
                    onChange={() => handleCellToggle(record, 'EventAutoMessageUse')}
                    disabled={!record.enabled}
                />
            ),
            align: 'center',
        },
        {
            title: 'FullLoopUse',
            dataIndex: 'FullLoopUse',
            key: 'FullLoopUse',
            render: (text, record) => (
                <Checkbox
                    checked={record.FullLoopUse}
                    onChange={() => handleCellToggle(record, 'FullLoopUse')}
                    disabled={!record.enabled}
                />
            ),
            align: 'center',
        },
        {
            title: 'AutoDocUse',
            dataIndex: 'AutoDocUse',
            key: 'AutoDocUse',
            render: (text, record) => (
                <Checkbox
                    checked={record.AutoDocUse}
                    onChange={() => handleCellToggle(record, 'AutoDocUse')}
                    disabled={!record.enabled}
                />
            ),
            align: 'center',
        },
    ];

    return (
        <div>
            {/* ปุ่ม Save ย้ายไปด้านขวา */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
                <Button
                    type="primary"
                    onClick={handleSave}

                    loading={loading}
                    disabled={isSaveDisabled}
                >
                    Save
                </Button>
            </div>

            {/* ตาราง */}
            <Table
                columns={columns}
                dataSource={data}
                loading={fetching}
                pagination={false}
                bordered
                rowClassName={(record) => (record.enabled ? 'enabled-row' : 'disabled-row')}
            />
        </div>
    );
};

export default TableEventAdmin;
